module.exports = __webpack_public_path__ + "static/media/ExoBNNVARA-Medium.68896ac8.woff";